// Client-side request deadlines (#2191 D11). Hand-written, not generated: the
// generated request core reads it through scripts/post-generate-api.js.

/**
 * The deadline of an analytics read. The server bounds the same routes at 60 s
 * (request-timeout middleware on /cockpit and /reconciliation), so a request
 * the server has already given up on stops waiting too.
 */
export const ANALYTICS_REQUEST_TIMEOUT_MS = 60_000;

const ANALYTICS_PREFIXES = ["/api/v1/cockpit/", "/api/v1/reconciliation/"];

/**
 * The axios `timeout` for a request, or undefined for none. Only analytics
 * reads are bounded: a write such as an invoice run or an import may run
 * longer than any fixed limit, and aborting it client-side would hide a
 * server-side success.
 */
export function requestTimeoutMs(method: string, url: string): number | undefined {
  if (method.toUpperCase() !== "GET") return undefined;
  return ANALYTICS_PREFIXES.some((prefix) => url.startsWith(prefix)) ? ANALYTICS_REQUEST_TIMEOUT_MS : undefined;
}
